import { createSelector } from '@reduxjs/toolkit'
import get from 'lodash/get'

const getComponentState = (state) => state.componentState
export const getVin = createSelector([getComponentState], (componentState) =>
  get(componentState, 'vin'),
)
